import { render, staticRenderFns } from "./lista-solicitud-baja.vue?vue&type=template&id=223aa28d&"
import script from "./lista-solicitud-baja.vue?vue&type=script&lang=js&"
export * from "./lista-solicitud-baja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports